<template>
  <div>
    <div style="width: 100%; display: flex; flex-direction: column; align-items: flex-start">
      <div class="event-header" v-if="model.issuer">
        <div class="event-title-container">
          <span
            class="fa fa-plus-circle event-icon list-membership-icon"
            style="margin-right: 10px"
          ></span>
          <span @click="onClickCompany(model.issuer)" class="lnk">{{ model.issuer.name }}</span>
        </div>
      </div>
    </div>
    <div>
      <div
        class="bold"
        style="
          margin-bottom: 10px;
          margin-left: 25px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        "
      >
        <span>
          {{ model.subEventType.name }}
        </span>
      </div>
      <div v-if="model.eventType === 'PIPELINE_REPORT_COMMENT'">
        <span v-html="model.comment" />
      </div>
      <div v-else>
        <table class="trade-instruction-table" style="table-layout: auto">
          <thead>
            <tr>
              <th style="text-align: left">Analyst</th>
              <th style="text-align: left">Source</th>
              <th style="text-align: left">Size</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-truncate" style="width: 45%; max-width: 45%; padding-right: 8px">
                {{ model.entry.analyst }}
              </td>
              <td class="text-truncate" style="width: 25%; max-width: 25%; padding-right: 8px">
                {{ model.entry.source }}
              </td>
              <td class="text-truncate" style="width: 25%; max-width: 25%">
                {{ model.entry.size }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import eventPopupMixin from '../../mixins/eventPopupMixin'

export default {
  mixins: [eventPopupMixin],
  props: {
    model: { type: Object, required: true }
  },

  computed: {
    issuers() {
      if (!this.event || !this.event.entities) {
        return []
      }

      // This filters out analysts and returns just issuers or tags
      const issuers = this.event.entities.filter(
        ({ fullName = null, entityType = '' }) =>
          !fullName && entityType !== 'COUNTRY' && entityType !== 'REGION'
      )

      return issuers
    },
    eventType() {
      if (!this.event) {
        return undefined
      }
      return this.event.eventType
    }
  }
}
</script>

<style lang="scss">
.event-title-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.event-tile.commentary {
  .event-header {
    div.p-message.p-component.p-message-success {
      font-size: 1rem;
      div.p-message-wrapper {
        padding: 0.2rem;
      }
    }
    .pi.pi-link.wb-link {
      cursor: pointer;
      color: #007ac9;
      margin-right: 10px;
    }
  }
}
</style>
